<template>
  <div class="head-nav">
    <div class="mobile-box" @click="psIsShow=!psIsShow">
      <div class="logo">
        <!--<img src="@/assets/m_img_logo@2x.png" width="133" style="padding:10px;"/>-->
        <img src="@/assets/m_img_logo@2x.png" width="133" height="20"/>
        <div class="list" v-show="!psIsShow"></div>
        <div class="list1" v-show="psIsShow"></div>
      </div>
      <div class="productsAndServices" v-show="psIsShow">
        <div class="ps-list" @click="gotoListItem('./')">首页</div>
        <div class="ps-list">
          <div>产品与服务</div>
          <div class="ps-ul">
            <div class="ps-li" @click="gotoListItem('/intelligentlogistics')">充电投资</div>
            <div class="ps-li" @click="gotoListItem('/chargingFranchise')">充电加盟</div>
            <div class="ps-li" @click="gotoListItem('/keyCustomers')">充电大客户</div>
          </div>
          <div class="ps-ul">
            <div class="ps-li" @click="gotoListItem('/transportationEnterprises')">运力企业</div>
            <div class="ps-li" @click="gotoListItem('/individualDriver')">个体司机</div>
            <div class="ps-li" @click="gotoListItem('/consignor')">货主</div>
            <div class="ps-li" @click="gotoListItem('/parkServices')">园区</div>
          </div>
        </div>
        <div class="ps-list" @click="gotoListItem('/case')">案例</div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .head-nav {
    z-index: 999;
    width: 100%;
    background: #fff7fb00;
    position: fixed;
    top: 0px;
  }
  @media screen and (max-width: 480px) {
    .head-nav {
      height:51px;
    }
    .head-nav .nav-box {
      display: none;
    }
    .head-nav .mobile-box {
      width: 100%;
      height:50px;
      position: relative;
      margin: 0 auto;
      background-color: #05123e;
      .logo{
        line-height: 50px;
        text-align: left;
        padding-left: 15px;
        .list{
          background-image: url('~@/assets/m_icon_menu@2x.png');
          width: 24px;
          height: 24px;
          background-size: 24px 24px;
          background-repeat: no-repeat;
          float: right;
          margin-top: 13px;
          margin-right: 15px;
        }
        .list1{
          background-image: url('~@/assets/mobile/m_icon_entrance@2x.png');
          width: 24px;
          height: 24px;
          background-size: 24px 24px;
          background-repeat: no-repeat;
          float: right;
          margin-top: 13px;
          margin-right: 15px;
        }
      }
      .productsAndServices{
        width: 100%;
        height: 100vh;
        line-height: 30px;
        color: #526BAB;
        position: absolute;
        top: 50px;
        padding: 20px 6px;
        z-index: 998;
        /*border-radius: 8px;*/
        background-color: #05123e;
        .ps-list{
          text-align: left;
          /*border-bottom: 1px solid;*/
          padding: 10px  10%;;
          font-size: 14px;
          line-height: 38px;
          .ps-ul{
            padding:0 20px;
            display: flex;
            .ps-li{
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
</style>
<script>
export default {
  data() {
    return {
      psIsShow: false,
      listData: [],
    }
  },
  props:{
    leftIndex: 0
  },
  mounted() {
    this.listData = this.energyList
    // this.clickNav();
  },
  methods: {
    gotoMenu() {
      //跳转到上一次浏览的页面  this.$router.go(-1)
      this.$router.go(-1)

      //指定跳转的地址 this.$router.replace('/menu')
      this.$router.replace('./menu')

      //指定跳转的路由的名字下 this.$router.replace({name:'menu'})
      this.$router.replace({ name: 'menu' })

      //通过push进行跳转
      this.$router.push('./menu')
    },
    gotoListItem(path){
      this.$router.push(path)
    }

  },
}
</script>
